module.exports = __webpack_public_path__ + "static/media/shower.13571dae.JPG";